import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import ErrorView from '@magento/venia-ui/lib/components/ErrorView';

var ProductRedirect = function ProductRedirect() {
  var _data$products2, _data$products2$items, _data$products3, _data$products3$items;

  var _useParams = useParams(),
      baseItemSku = _useParams.baseItemSku,
      skuLevelItemSku = _useParams.skuLevelItemSku;

  var _useLocation = useLocation(),
      search = _useLocation.search;

  var _useQuery = useQuery(GET_PRODUCT, {
    fetchPolicy: 'cache-and-network',
    skip: !baseItemSku,
    variables: {
      sku: baseItemSku.toUpperCase()
    }
  }),
      data = _useQuery.data,
      error = _useQuery.error,
      loading = _useQuery.loading;

  if (baseItemSku == '131311' && search == 'utm_source=Lux+Magazine&utm_medium=Print&utm_campaign=LUXE_sept-oct2022') {
    return React.createElement(Redirect, {
      to: '/collection-landing/arc'
    });
  }

  var targetSkuUid = false;

  if (skuLevelItemSku) {
    var _data$products, _data$products$items$, _data$products$items$2, _data$products$items$3;

    targetSkuUid = data === null || data === void 0 ? void 0 : (_data$products = data.products) === null || _data$products === void 0 ? void 0 : (_data$products$items$ = _data$products.items[0]) === null || _data$products$items$ === void 0 ? void 0 : (_data$products$items$2 = _data$products$items$.variants) === null || _data$products$items$2 === void 0 ? void 0 : (_data$products$items$3 = _data$products$items$2.find(function (variant) {
      return variant.product.sku == skuLevelItemSku;
    })) === null || _data$products$items$3 === void 0 ? void 0 : _data$products$items$3.product.uid;
  }

  var redirectTo = data !== null && data !== void 0 && (_data$products2 = data.products) !== null && _data$products2 !== void 0 && (_data$products2$items = _data$products2.items[0]) !== null && _data$products2$items !== void 0 && _data$products2$items.url_key ? "/" + (data === null || data === void 0 ? void 0 : (_data$products3 = data.products) === null || _data$products3 === void 0 ? void 0 : (_data$products3$items = _data$products3.items[0]) === null || _data$products3$items === void 0 ? void 0 : _data$products3$items.url_key) + (targetSkuUid ? '?selected_variant=' + targetSkuUid : '') : false;

  if (redirectTo) {
    return React.createElement(Redirect, {
      to: redirectTo
    });
  }

  return React.createElement(ErrorView, null);
};

var GET_PRODUCT = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getProductUrl($sku: String) {\n        products(filter: { sku: { eq: $sku } }) {\n            items {\n                sku\n                uid\n                url_key\n                ... on ConfigurableProduct {\n                    variants {\n                        # eslint-disable-next-line @graphql-eslint/require-id-when-available\n                        product {\n                            sku\n                            uid\n                        }\n                    }\n                }\n            }\n        }\n    }\n"])));
export default ProductRedirect;